
export function normalizeAllocationNumber(value: string): string {
  return value.replace(/\s+/g, "").trim();
}

export function formatAllocationNumber(value: string): string {
  const normalized = normalizeAllocationNumber(value);
  if (!/^\d+$/.test(normalized)) return value.trim();

  const groups: string[] = [];
  let cursor = normalized.length;

  while (cursor > 3) {
    groups.unshift(normalized.slice(cursor - 3, cursor));
    cursor -= 3;
  }

  groups.unshift(normalized.slice(0, cursor));
  return groups.join(" ");
}
